export default {
    barHeaderTitleSent: 'barHeaderTitleSent',
    barHeaderTitleFailed: 'barHeaderTitleFailed',
    barHeaderSubtitle: 'barHeaderSubtitle',
    successHeadline: 'successHeadline',
    failHeadline: 'failHeadline',
    // below error codes are provided in graphql
    ITEM_HAS_LEAD_TIME: 'ITEM_HAS_LEAD_TIME',
    ITEM_NOT_AVAILABLE: 'ITEM_NOT_AVAILABLE',
    ITEM_ON_HOLD: 'ITEM_ON_HOLD',
    SYSTEM_ERROR: 'SYSTEM_ERROR',
    DUPLICATE_REQUEST: 'DUPLICATE_REQUEST',
    CHECKOUT_COMPLETE: 'CHECKOUT_COMPLETE',
    MULTIPLE_QUANTITIES_AVAILABLE: 'MULTIPLE_QUANTITIES_AVAILABLE',
    GENERAL_INQUIRY: 'GENERAL_INQUIRY',
    SHIPPING_QUOTE_RECEIVED: 'SHIPPING_QUOTE_RECEIVED',
    AUCTION_ITEM: 'AUCTION_ITEM',
};
